import { Component, OnInit, Input, EventEmitter, Output, ComponentFactoryResolver, ViewChild, ViewContainerRef } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { CommonService } from '../../../services/common.service';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { DataService } from '../../../services/forms/cheque-register/data.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { Employee } from '../../../models/employee.model';
import { GridService } from 'src/app/shared/services/grid.service';
@Component({
    selector: 'app-accounts-list',
    templateUrl: './../../../templates/forms/modals/import-lc-no.component.html',
})
export class ImportLcNoListComponent implements OnInit {

    @ViewChild('modalContainer', { static: true, read: ViewContainerRef }) container;

    @Input()
    config: any;

    @Input()
    modalShow: boolean = true;

    @Output()
    submit: EventEmitter<any> = new EventEmitter<any>();

    dataObj: any;
    columnDefs = [];
    colObj;
    grid: any;
    gridId: string = "ImportLcNoListGrid"
    importLcNoList: any[] = [];
    searchFields: any[] = ['PURDOCUMENT_ID', 'OPENING_DATE', 'OWN_BANKDTL', 'SUPPLIER_BANK'];
    public searchString;
    //constructor(public langService: LangService, private dataService: DataService) { }
    private modal: ModalService;

    constructor(public langService: LangService, private dataService: CommonService,
        public gridService: GridService) {
        this.colObj = [
            { headerName: langService.langData.PurDocumentId, field: 'PURDOCUMENT_ID', sortable: true, resizable: true, hide: false },
            { headerName: langService.langData.openingDate, field: 'OPENING_DATE', sortable: true, resizable: true, hide: false },
            { headerName: langService.langData.ownBankDtlL, field: 'OWN_BANKDTL', sortable: true, resizable: true, hide: false },
            { headerName: langService.langData.supplierBank, field: 'SUPPLIER_BANK', sortable: true, resizable: true, hide: false }
        ];
    }
    ngOnInit() {
        this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
    }

    onGridReady(grid) {
        this.grid = grid;
        this.gridService.sizeColumnsToFit(grid, this.gridId);

        this.dataService.getImportLcNo().subscribe(arg => {
            this.importLcNoList = arg.body
        });
    }
    itemClick(_item) {
        this.modalShow = false;
        this.dataObj = _item;
        this.submit.next();
    }
}
